<template>
  <v-bottom-navigation
    app
    v-model="nav"
    :min-height="iPhoneX ? 80 : 0"
    color="#FF5500"
  >
    <template
      v-for="item in buttons"
    >
      <v-btn
        :key="item.value"
        :value="item.value"
        @click.stop="changeNav(item)"
      >
        <span>{{ item.name }}</span>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            v-for="dd in item.d"
            :key="dd"
            :fill-rule="item.fillRule"
            :clip-rule="item.clipRule"
            :d="dd"
            :fill="nav == item.value ? '#FF5500' : '#929191'"
          />
          <circle
            v-if="(item.value === 'inbox' && hasUnread) || (item.value === 'Activity' && hasUncheck)"
            cx="21" cy="3" r="3" fill="#FF5500"
          />
        </svg>
      </v-btn>
    </template>
    <v-btn
      v-if="$vuetify.breakpoint.name != 'xs' && !isLogin"
      class="px-0"
      value="signIn"
      @click.stop="routerPush('/signIn/signInTemp')"
    >
      <span>Log In</span>
      <v-icon>mdi-login</v-icon>
    </v-btn>
    <v-btn
      v-if="$vuetify.breakpoint.name != 'xs' && isLogin"
      class="px-0"
      value="signOut"
      @click.stop="routerPush('/signOut')"
    >
      <span>Log Out</span>
      <v-icon>mdi-exit-run</v-icon>
    </v-btn>

    <notSignInDialog
      ref="notSignInDialog"
      title="Oops!"
      description="It looks like you have not been on Paike yet."
      @click="gotoNextPage"
    ></notSignInDialog>

  </v-bottom-navigation>
</template>

<script>
import firebase from "firebase/app"
import "firebase/auth"
import notSignInDialog from '@/components/Like/NotSignInDialog'
import service from '@/plugins/service'

export default {
  components: {
    notSignInDialog,
  },
  props: {
    activeNav: { type: String, required: true, },
    changeRoute: { type: Boolean, required: false, default: true, }
  },
  data: () => ({
    user: {},
    nav: '',
    nextPage: '',
    hasUnread: false,
    hasUncheck: false,
    buttons: [
      {
        value: 'likes',
        route: '/likes',
        name: 'Explore',
        icon: 'mdi-magnify',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: [
          'M15.1866 14.4716H15.9766L20.2166 18.7316C20.6266 19.1416 20.6266 19.8116 20.2166 20.2216C19.8066 20.6316 19.1366 20.6316 18.7266 20.2216L14.4766 15.9716V15.1816L14.2066 14.9016C12.8066 16.1016 10.8966 16.7216 8.86656 16.3816C6.08656 15.9116 3.86656 13.5916 3.52656 10.7916C3.00656 6.56157 6.56656 3.00157 10.7966 3.52157C13.5966 3.86157 15.9166 6.08157 16.3866 8.86157C16.7266 10.8916 16.1066 12.8016 14.9066 14.2016L15.1866 14.4716ZM5.47656 9.97157C5.47656 12.4616 7.48656 14.4716 9.97656 14.4716C12.4666 14.4716 14.4766 12.4616 14.4766 9.97157C14.4766 7.48157 12.4666 5.47157 9.97656 5.47157C7.48656 5.47157 5.47656 7.48157 5.47656 9.97157Z'
        ],
      },
      {
        value: 'Activity',
        route: '/activity',
        name: 'Activity',
        icon: 'mdi-bookmark-multiple-outline',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: [
          'M16.6492 21C16.3053 20.9992 15.9739 20.8701 15.7181 20.6375L15.6342 20.56C12.8609 18.0075 11.026 16.3225 11.105 14.115C11.1227 13.6146 11.2555 13.1252 11.4931 12.686C11.7306 12.2467 12.0662 11.8697 12.4731 11.585C13.0137 11.2058 13.6553 11.0018 14.313 11C15.1835 11.0069 16.0198 11.3441 16.6566 11.945C17.2919 11.3468 18.1251 11.0106 18.9928 11.0025C19.6498 11.0037 20.2911 11.2059 20.8326 11.5825C21.2402 11.8673 21.5763 12.2447 21.8143 12.6843C22.0523 13.124 22.1854 13.614 22.2032 14.115C22.2773 16.3225 20.4325 18.015 17.6419 20.5775L17.5851 20.63C17.3302 20.8682 16.996 21.0003 16.6492 21ZM14.3154 12.75C14.1186 12.7415 13.9222 12.7745 13.7386 12.8469C13.555 12.9193 13.3883 13.0294 13.249 13.1705C13.1097 13.3115 13.0009 13.4802 12.9294 13.6661C12.8579 13.8519 12.8253 14.0508 12.8337 14.25C12.8337 15.585 14.3426 17 16.6467 19.1125C18.9631 16.9975 20.4745 15.5825 20.4745 14.25C20.4829 14.0508 20.4503 13.8519 20.3788 13.6661C20.3073 13.4802 20.1985 13.3115 20.0592 13.1705C19.9199 13.0294 19.7531 12.9193 19.5696 12.8469C19.386 12.7745 19.1896 12.7415 18.9928 12.75C18.6689 12.7527 18.3527 12.8499 18.082 13.0299C17.8113 13.21 17.5976 13.4652 17.4666 13.765L17.3801 13.9925H15.933L15.8465 13.7675C15.7151 13.4675 15.5004 13.2127 15.2286 13.0338C14.9568 12.855 14.6396 12.7599 14.3154 12.76V12.75Z',
          'M11.0648 18.0934L9.59472 17.6172V4.0466L13.6274 5.35431V9.97325C13.8735 9.93105 14.1227 9.90959 14.3724 9.9091C14.7269 9.91079 15.08 9.95218 15.4252 10.0325V5.36171L19.4579 4.054V9.93871C20.067 10.0025 20.6575 10.1844 21.1961 10.4741V2.86472C21.1967 2.72827 21.1646 2.59364 21.1026 2.47192C21.0405 2.3502 20.9502 2.24488 20.8391 2.16463C20.7281 2.08439 20.5994 2.03153 20.4637 2.01039C20.3281 1.98926 20.1893 2.00046 20.0588 2.04308L14.5288 3.83687L8.99379 2.04308C8.97257 2.03755 8.951 2.03343 8.92923 2.03074C8.89476 2.02489 8.8599 2.02159 8.82494 2.02087H8.6238L8.51951 2.04308C8.49964 2.04308 8.47729 2.04308 8.45494 2.05542L2.61948 3.9479C2.4448 4.00421 2.29256 4.11404 2.1846 4.26166C2.07664 4.40927 2.01851 4.58707 2.01855 4.76954V20.1364C2.01921 20.3653 2.11099 20.5845 2.27384 20.7463C2.43668 20.9082 2.65736 20.9993 2.88767 21C2.97972 20.9999 3.07114 20.9849 3.15833 20.9556L8.72561 19.1519L13.5852 20.7286C12.6705 19.9237 11.8273 19.042 11.0648 18.0934ZM7.8565 17.6172L3.75678 18.9447V5.37405L7.8565 4.054V17.6172Z',
        ],
      },
      {
        value: 'favorite',
        route: '/post/new',
        name: 'Shots',
        icon: 'mdi-pencil-plus-outline',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: [
          'M12.0002 11C11.5559 10.996 11.1205 11.1243 10.7493 11.3684C10.3781 11.6126 10.0879 11.9616 9.91556 12.3711C9.74325 12.7807 9.69661 13.2322 9.78158 13.6683C9.86655 14.1044 10.0793 14.5054 10.3928 14.8202C10.7062 15.1351 11.1062 15.3497 11.542 15.4366C11.9777 15.5235 12.4294 15.4789 12.8397 15.3084C13.25 15.138 13.6003 14.8493 13.8462 14.4792C14.092 14.1091 14.2222 13.6743 14.2202 13.23C14.2215 12.9376 14.1651 12.6478 14.0541 12.3773C13.9431 12.1068 13.7798 11.8609 13.5735 11.6537C13.3673 11.4465 13.1221 11.2821 12.8521 11.1699C12.5821 11.0577 12.2926 11 12.0002 11Z',
          'M22.37 7C22.1716 6.79809 21.935 6.63755 21.6741 6.52769C21.4132 6.41783 21.1331 6.36084 20.85 6.36H18.52C18.4264 6.35985 18.3348 6.33231 18.2566 6.28078C18.1785 6.22925 18.1171 6.15599 18.08 6.07L17.38 4.51C17.2092 4.12382 16.9284 3.79648 16.5727 3.56885C16.2171 3.34122 15.8022 3.22337 15.38 3.23H8.59C8.16777 3.22337 7.75294 3.34122 7.39726 3.56885C7.04159 3.79648 6.76082 4.12382 6.59 4.51L5.92 6.1C5.88294 6.18599 5.82153 6.25925 5.74336 6.31078C5.66518 6.36231 5.57363 6.38985 5.48 6.39H3.15C2.57795 6.39527 2.03113 6.62622 1.62849 7.03261C1.22585 7.43899 0.999976 7.98793 1 8.56V18.56C1.00015 19.1302 1.22676 19.6769 1.63 20.08C1.82706 20.2837 2.06331 20.4455 2.32454 20.5555C2.58577 20.6655 2.86656 20.7214 3.15 20.72H20.85C21.1334 20.7214 21.4142 20.6655 21.6755 20.5555C21.9367 20.4455 22.1729 20.2837 22.37 20.08C22.7684 19.6818 22.9946 19.1432 23 18.58V8.58C23.008 8.28764 22.9562 7.99672 22.8479 7.72505C22.7396 7.45338 22.577 7.20666 22.37 7ZM21.37 18.55C21.3696 18.6154 21.3562 18.6801 21.3304 18.7402C21.3046 18.8003 21.2671 18.8546 21.22 18.9C21.1308 18.9927 21.0086 19.0466 20.88 19.05H3.15C3.02137 19.0466 2.89924 18.9927 2.81 18.9C2.76291 18.8546 2.72537 18.8003 2.69961 18.7402C2.67385 18.6801 2.66038 18.6154 2.66 18.55V8.55C2.65961 8.48301 2.67269 8.41662 2.69845 8.35477C2.72422 8.29293 2.76215 8.2369 2.81 8.19C2.85469 8.14546 2.90772 8.11018 2.96606 8.08615C3.0244 8.06213 3.08691 8.04985 3.15 8.05H5.48C5.90223 8.05663 6.31706 7.93878 6.67274 7.71115C7.02841 7.48352 7.30918 7.15619 7.48 6.77L8.18 5.21C8.21834 5.12211 8.28115 5.0471 8.36094 4.99391C8.44072 4.94072 8.53412 4.91159 8.63 4.91H15.45C15.5451 4.90948 15.6382 4.93662 15.7181 4.98811C15.798 5.03961 15.8612 5.11322 15.9 5.2L16.6 6.77C16.7708 7.15619 17.0516 7.48352 17.4073 7.71115C17.7629 7.93878 18.1778 8.05663 18.6 8.05H20.93C20.9931 8.04985 21.0556 8.06213 21.1139 8.08615C21.1723 8.11018 21.2253 8.14546 21.27 8.19C21.3178 8.2369 21.3558 8.29293 21.3815 8.35477C21.4073 8.41662 21.4204 8.48301 21.42 8.55V18.55H21.37Z',
          'M12.0002 8.33998C10.8714 8.33736 9.77654 8.72617 8.90219 9.44019C8.02785 10.1542 7.42809 11.1493 7.20507 12.2559C6.98206 13.3625 7.14959 14.5122 7.67912 15.5091C8.20866 16.5061 9.06744 17.2886 10.1092 17.7234C11.1509 18.1582 12.3112 18.2184 13.3924 17.8938C14.4735 17.5691 15.4087 16.8797 16.0386 15.9429C16.6685 15.0061 16.9541 13.8799 16.8468 12.7562C16.7395 11.6325 16.246 10.5807 15.4502 9.77998C14.998 9.32498 14.4606 8.9636 13.8686 8.71651C13.2766 8.46942 12.6417 8.34147 12.0002 8.33998ZM14.5402 15.82C14.2082 16.1562 13.8127 16.4231 13.3767 16.6053C12.9406 16.7875 12.4728 16.8813 12.0002 16.8813C11.5277 16.8813 11.0598 16.7875 10.6238 16.6053C10.1878 16.4231 9.7923 16.1562 9.46024 15.82C8.78782 15.1356 8.41106 14.2144 8.41106 13.255C8.41106 12.2955 8.78782 11.3744 9.46024 10.69C9.7923 10.3538 10.1878 10.0868 10.6238 9.90463C11.0598 9.72244 11.5277 9.62862 12.0002 9.62862C12.4728 9.62862 12.9406 9.72244 13.3767 9.90463C13.8127 10.0868 14.2082 10.3538 14.5402 10.69C15.2127 11.3744 15.5894 12.2955 15.5894 13.255C15.5894 14.2144 15.2127 15.1356 14.5402 15.82Z',
          'M18.5901 9.48999C18.3938 9.48999 18.2056 9.56795 18.0668 9.70673C17.9281 9.84551 17.8501 10.0337 17.8501 10.23C17.8501 10.4263 17.9281 10.6145 18.0668 10.7532C18.2056 10.892 18.3938 10.97 18.5901 10.97C18.7864 10.97 18.9746 10.892 19.1134 10.7532C19.2521 10.6145 19.3301 10.4263 19.3301 10.23C19.3301 10.0337 19.2521 9.84551 19.1134 9.70673C18.9746 9.56795 18.7864 9.48999 18.5901 9.48999Z',
        ],
      },
      {
        value: 'inbox',
        route: '/inbox',
        name: 'Messages',
        icon: 'mdi-chat-processing',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: [
          'M4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H6L2 22V4C2 2.9 2.9 2 4 2ZM6 16H19C19.55 16 20 15.55 20 15V5C20 4.45 19.55 4 19 4H5C4.45 4 4 4.45 4 5V18L6 16Z'
        ],
      },
      {
        value: 'myProfile',
        route: '/profile',
        name: 'Profile',
        icon: 'mdi-account-circle-outline',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: [
          'M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14.1 8C14.1 6.84 13.16 5.9 12 5.9C10.84 5.9 9.9 6.84 9.9 8C9.9 9.16 10.84 10.1 12 10.1C13.16 10.1 14.1 9.16 14.1 8ZM18.1 17C18.1 16.36 14.97 14.9 12 14.9C9.03 14.9 5.9 16.36 5.9 17V18.1H18.1V17ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17Z'
        ],
      },
    ],
  }),
  async mounted() {
    const self = this
    firebase.auth().onAuthStateChanged(async (user) => {
      if (!(!user)) {
        self.user = user
        service.hasUnread(user.uid).then(res => {
          self.hasUnread = res
        })
        service.hasUnCheck(user.uid).then(res => {
          self.hasUncheck = res
        })
      }
    })
    this.nav = this.activeNav
  },
  computed: {
    isLogin() {
      return !(!this.user.uid)
    },
    iPhoneX() {
      const isiPhone = /iPhone/.test(window.navigator.userAgent);
      const currentDevicePixel = (window.screen.width * window.screen.height * window.devicePixelRatio);
      const iPhoneXSeriesScreenPixelList = [
        (375 * 812 * 3), // iPhoneX or Xs
        (414 * 896 * 3), // iPhoneXsMax
        (414 * 896 * 2), // iPhoneXR
      ];
      const result = isiPhone && iPhoneXSeriesScreenPixelList.some((item) => item === currentDevicePixel);
      return result
    },
  },
  methods: {
    async routerPush(route) {
      if (this.$route.path == route) {
        return
      }
      this.$router.push(route)
    },
    changeNav(item) {
      let route = item.route
      if (this.$route.path == route) {
        // 同じタブに移動しようとしたときは何もしない
        return
      }
      if (!this.isLogin && item.value != 'likes') {
        // ログインしていない場合はログインを促す
        this.nextPage = route
        this.$refs.notSignInDialog.show()
        return
      }
      if (this.changeRoute) {
        // Routeを切り替えてよい場合は切り替える
        this.$router.push(route)
      } else {
        // Routeを切り替えてはいけない場合は、クリックされたRouteをclickベントで返す
        this.$emit('change', route)
      }
    },
    gotoNextPage() {
      this.$router.push(this.nextPage)
    }
  }
}
</script>

<style lang="stylus" scoped>
span
  font-size 7pt
  letter-spacing 0
</style>
